const hexRegexp = /^[0-9a-fA-F]*$/;

export const hexInputCheck = (value: string, callback: (value: string) => void) => {
  if (hexRegexp.test(value)) {
    callback(value.toUpperCase());
  } else {
    callback(value.replace(/[^0-9a-fA-F]/g, "").toUpperCase());
  }
};

export const patternInputCheck = (value: string, enabledCharacters: string, callback: (value: string) => void) => {
  const regexp = new RegExp(`[${enabledCharacters}]*`, "g");
  if (value.match(regexp)?.join("") === value) {
    callback(value);
  } else {
    const replaceRegexp = new RegExp(`[^${enabledCharacters}]`, "g");
    callback(value.replace(replaceRegexp, ""));
  }
};

export const formatMac = (mac: string) => {
  if (!mac) {
    return mac;
  }
  const regex = /([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})/i;
  if (!regex.test(mac)) {
    return mac;
  }
  return mac.replace(regex, "$1-$2-$3-$4-$5-$6");
};

export const valueEdited = (old: any, current: any, next: any): boolean => {
  if (!current) {
    return old !== next;
  } else {
    return old !== current;
  }
};
